<template>
    <v-container fluid class="mx-0 px-1 my-0 py-0">
        <v-row
            class="team-banner secondary-font"
            :class="{ 'team-banner-compact': compact }"
            :style="`background: linear-gradient(160deg, ${safeMatch.team1Score > safeMatch.team2Score ? (safeMatch.team1?.color ? safeMatch.team1?.color : 'orange') : '#bbb7b6'} 50%, ${safeMatch.team2Score > safeMatch.team1Score ? (safeMatch.team2?.color ? safeMatch.team2?.color : 'orange') : '#bbb7b6'} 50%);`"
            justify="center"
            align="center"
        >
            <v-col :cols="compact ? 'auto' : 4" :md="compact ? 'auto' : 4" class="pb-0 mb-0 clickable" :class="compact ? 'px-2' : ''" @click.stop="goToTeam(safeMatch.team1)">
                <v-img
                    :src="`${assetsUrl}/${safeMatch.team1?.logo}`"
                    :height="compact ? 56 : 150"
                    :width="compact ? 56 : null"
                    contain
                />
            </v-col>
            <v-col v-if="safeMatch.team1Score > 0 || safeMatch.team2Score > 0" :cols="compact ? 'auto' : 4" :md="compact ? 'auto' : 2" align="center">
                <v-row align="center" justify="center" no-gutters class="score-dashboard rounded-lg my-0 mx-0">
                    <span
                        :class="safeMatch.team1Score > safeMatch.team2Score ? 'winning-score' : ''"
                    >
                        <span class="white--text font-weight-bold score-value" :class="{ 'score-value-compact': compact }">{{ safeMatch.team1Score }}</span>
                    </span>
                    <span class="divider-wrap">
                        <v-divider
                            vertical
                            color="white"
                            class="custom-divider mx-2"
                        />
                    </span>
                    <span
                        :class="safeMatch.team2Score > safeMatch.team1Score ? 'winning-score' : ''"
                    >
                        <span class="white--text font-weight-bold score-value" :class="{ 'score-value-compact': compact }">{{ safeMatch.team2Score }}</span>
                    </span>
                </v-row>
            </v-col>
            <v-col v-else :cols="compact ? 'auto' : 4" :md="compact ? 'auto' : 2" align="center">
                <span class="score-dashboard rounded-lg d-inline-flex align-center justify-center">
                    <span class="custom-orange-text font-weight-bold vs-value" :class="{ 'vs-value-compact': compact }">VS</span>
                </span>
            </v-col>
            <v-col :cols="compact ? 'auto' : 4" :md="compact ? 'auto' : 4" class="pb-0 mb-0 clickable" :class="compact ? 'px-2' : ''" @click.stop="goToTeam(safeMatch.team2)">
                <v-img
                    v-if="safeMatch.team2?.logo"
                    :src="`${assetsUrl}/${safeMatch.team2?.logo}`"
                    :height="compact ? 56 : 150"
                    :width="compact ? 56 : null"
                    contain
                />
                <v-icon v-else :style="compact ? 'font-size: 32px' : ($vuetify.breakpoint.mobile ? 'font-size: 64px' : 'font-size: 90px')" class="orange--text"> mdi-basketball </v-icon>
            </v-col>
            <template v-if="!compact">
                <v-col cols="12" align="center" class="my-0 py-0 text-subtitle-1 secondary-font">
                    <span v-if="!safeMatch.cup"> {{ safeMatch.league?.title || 'League' }}, </span>
                    <span> Round {{ safeMatch.round || 0 }}, </span>
                    <span>
                        {{ safeMatch.cup? 'Κύπελλο' : (safeMatch.phase === 'regular_season' ? 'Regular Season' : (safeMatch.phase === 'placements' ? 'Προκριματικά' : 'Play Offs')) }}
                    </span>
                </v-col>
                <v-col cols="12" align="center" class="text-subtitle-1 secondary-font py-0 my-0 pb-4">
                    {{ getDate(safeMatch.matchDatetime) }}
                </v-col>
            </template>
            <v-col v-else cols="12" align="start" class="compact-meta-row secondary-font">
                <span v-if="!safeMatch.cup"> {{ safeMatch.league?.title || 'League' }}, </span>
                <span> Round {{ safeMatch.round || 0 }}, </span>
                <span>
                    {{ safeMatch.cup? 'Κύπελλο' : (safeMatch.phase === 'regular_season' ? 'Regular Season' : (safeMatch.phase === 'placements' ? 'Προκριματικά' : 'Play Offs')) }},
                </span>
                {{ getDate(safeMatch.matchDatetime) }}
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    export default {
        props: {
            match: {
                type: Object,
                default: null
            },
            compact: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                team: {},
                assetsUrl: 'https://storage.googleapis.com'
            }
        },
        computed: {
            safeMatch() {
                return this.match || {}
            }
        },
        methods: {
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').locale('el-GR').format('dddd D/M/y, HH:mm').toString()
            },
            goToTeam(team) {
                if (!team || !team.id) return
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style scoped>
.score-text {
    font-size: 4rem;
}

.winning-score {
    background: linear-gradient(#00f7d1, #00ec80);
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.score-dashboard {
    background-color: #00000091;
    display: inline-flex !important;
    width: auto !important;
    flex: 0 0 auto;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow: hidden;
    padding: 14px 22px !important;
}

.score-value {
    font-size: clamp(1.5rem, 8vw, 4rem);
    line-height: 1.1;
    white-space: nowrap;
}

.score-value-compact {
    font-size: clamp(0.95rem, 3.6vw, 2rem);
}

.vs-value {
    font-size: clamp(1.3rem, 6.5vw, 2.6rem);
    white-space: nowrap;
}

.vs-value-compact {
    font-size: clamp(1rem, 3.6vw, 1.4rem);
}

@media (max-width: 600px) {
    .score-value {
        font-size: clamp(2.1rem, 10vw, 3.25rem);
    }

    .vs-value {
        font-size: clamp(1.7rem, 10vw, 2.4rem);
    }
}

.team-name {
    font-size: 2.2rem;
    font-weight: 800;
}

.win-lose-score {
    font-size: 2.2rem;
    font-weight: 800;
}

.win-lose-text {
    font-size: 1rem;
}

.custom-divider {
    border-width: 1px;
    height: clamp(27px, 6vw, 55px);
}

.divider-wrap {
    display: inline-flex;
    align-items: center;
    align-self: center;
}

.team-banner {
    color: white;
    font-size: 1.5rem;
    background: linear-gradient(160deg, orange 50%, #bbb7b6 50%);
    overflow-anchor: none;
    transition: opacity 0.2s ease;
}

.team-banner-compact {
    min-height: 64px;
    padding: 4px 12px;
}

.team-banner-compact .custom-divider {
    height: 18px;
}

.team-banner-compact .score-dashboard {
    padding: 4px 20px !important;
}

.compact-meta-row {
    width: 100%;
    margin: 2px 0 0;
    padding: 0 4px !important;
    font-size: clamp(0.58rem, 1.8vw, 0.76rem);
    line-height: 1.2;
    color: rgba(255, 255, 255, 0.85);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 600px) {
    .score-dashboard {
        padding: 12px 34px !important;
    }

    .compact-meta-row {
        font-size: 0.6rem;
    }
}
</style>
